import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/bottomBar.css';
// helpers
import {getFormattedCurrency, getText} from '../../../../../../helpers/localization';
import {isLocalStorageAvailable} from '../../../../../../helpers/systemHelpers';

// constants
import {ASSETS_URL} from '../../../../../../constants/endpoints';
import {CHIPS_LIST_MODAL_TYPE} from '../../../../../../constants/identifiers';
import {CHIPS, getHumanReadableChipValue} from '../../../../../../constants/chips';
import {EXACTA, PLACE, SHOW, TRIFECTA, WIN} from '../../../../modules/racing/constants/identifiers';
// actions
import {removeAllBets, undoLastBetAction} from '../../../../actions/openBetsActions';
import {openCloseModal} from '../../../../../../actions/modalActions';
import {openCloseBetBetHistory} from '../../../../actions/betHistoryActions';
import {openCloseHelpPages} from '../../../../../../actions/helpPagesActions';
import {openCloseSettings} from '../../../../../../actions/settingsActions';
import {OPERATOR} from '../../../../../../constants/operator';
import {fakePlaceBets, placeAndClearOpenBets} from '../../../../helpers/betHelpers';
import {clearEventOpenBets} from '../../../../../../actions/eventsActions';
import {
    selectRacingBetType,
    toggleBettingTypeButtonsDisplayed,
    toogleBoxBets
} from '../../../../modules/racing/actions/raceCardActions';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedEventId: state.vpp.selectedEventId,
        events: state.vpp.events,
        isDesktopMode: state.vpp.isDesktopMode,
        isSimpleBetsSelected: state.vpp.isSimpleBetsSelected,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedFootballBetType: state.vpp.selectedFootballBetType,
        openBetsHistory: state.vpp.openBetsHistory,
        openBetsList: state.vpp.openBetsList,
        selectedGameIndex: state.vpp.selectedGameIndex,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        selectedChip: state.vpp.selectedChip,
        isBoxBetsButtonToggled: state.vpp.isBoxBetsButtonToggled,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        settledBets: state.vpp.settledBets,
        games: state.vpp.games
    };
};

class BottomBar extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedEventId: storeData.vpp.selectedEventId,
            events: storeData.vpp.events,
            isDesktopMode: storeData.vpp.isDesktopMode,
            isSimpleBetsSelected: storeData.vpp.isSimpleBetsSelected,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedFootballBetType: storeData.vpp.selectedFootballBetType,
            openBetsHistory: storeData.vpp.openBetsHistory,
            openBetsList: storeData.vpp.openBetsList,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            selectedChip: storeData.vpp.selectedChip,
            isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            settledBets: storeData.vpp.settledBets,
            flashBetHistoryButton: false,
            games: storeData.vpp.games
        };
    }

    componentWillReceiveProps(nextProps) {
        let existsUnreadSettledBets = false;
        if (isLocalStorageAvailable) {
            let unreadLocalBets = sessionStorage.getItem('UNREAD_BETS');
            if (unreadLocalBets !== undefined && unreadLocalBets !== null) {
                unreadLocalBets = JSON.parse(unreadLocalBets);
                existsUnreadSettledBets = !unreadLocalBets.playerWasNotified && unreadLocalBets.settledBets !== undefined && unreadLocalBets.settledBets.length > 0;

                if (existsUnreadSettledBets) {
                    setTimeout(() => this.setState({
                        ...this.state,
                        flashBetHistoryButton: false
                    }), 10000);

                    unreadLocalBets.playerWasNotified = true;
                    sessionStorage.setItem('UNREAD_BETS', JSON.stringify(unreadLocalBets));
                }
            }
        }

        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedEventId: storeData.vpp.selectedEventId,
                events: storeData.vpp.events,
                isDesktopMode: storeData.vpp.isDesktopMode,
                isSimpleBetsSelected: storeData.vpp.isSimpleBetsSelected,
                selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                selectedFootballBetType: storeData.vpp.selectedFootballBetType,
                openBetsHistory: storeData.vpp.openBetsHistory,
                openBetsList: storeData.vpp.openBetsList,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                selectedChip: storeData.vpp.selectedChip,
                isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                settledBets: storeData.vpp.settledBets,
                flashBetHistoryButton: existsUnreadSettledBets
                    ? true
                    : this.state.flashBetHistoryButton,
                games: storeData.vpp.games
            });
        }

    }

    _generateBetTypeSwitchButton() {
        let store = this.props.store;
        let storeData = store.getState();
        let hasPlace = storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].markets && storeData.vpp.events[storeData.vpp.selectedEventIndex].markets.find(
            (mkt) => mkt.code === Number(PLACE.code)
        );
        let hasShow = storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].markets && storeData.vpp.events[storeData.vpp.selectedEventIndex].markets.find(
            (mkt) => mkt.code === Number(SHOW.code)
        );

        let hasTrifecta = !this.state.isSimpleBetsSelected && storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.tricast;

        let secondLine;
        let nextBetType;
        let separator;

        switch (this.state.selectedRacingBetType) {
            case WIN:
                if (hasPlace) {
                    secondLine = (
                        <div id={'nextBetTypeSelected'}
                             className={style.bottomBaseButtonBottomLine}>{getText('PLACE', this.props.store).toUpperCase()}</div>
                    );
                    nextBetType = PLACE;
                    separator = (<div className={style.bottomBaseButtonSeparator}></div>);
                } else {
                    secondLine = '';
                    nextBetType = WIN;
                    separator = '';
                }
                return (
                    <div
                        id={'selectBetTypeButton'}
                        className={style.bottomBaseButton}
                        onClick={() => this.props.store.dispatch(selectRacingBetType(nextBetType))}>
                        <div id={'currentBetTypeSelected'}
                             className={style.bottomBaseButtonTopLine}>{getText('WIN', this.props.store).toUpperCase()}</div>
                        {separator}
                        {secondLine}
                    </div>
                );
            case PLACE:
                if (hasShow) {
                    secondLine = (
                        <div id={'nextBetTypeSelected'}
                             className={style.bottomBaseButtonBottomLine}>{getText('SHOW', this.props.store).toUpperCase()}</div>
                    );
                    nextBetType = SHOW;
                } else {
                    secondLine = (<div
                        className={style.bottomBaseButtonBottomLine}>{getText('WIN', this.props.store).toUpperCase()}</div>);
                    nextBetType = WIN;
                }
                return (
                    <div
                        id={'selectBetTypeButton'}
                        className={style.bottomBaseButton}
                        onClick={() => this.props.store.dispatch(selectRacingBetType(nextBetType))}>
                        <div id={'currentBetTypeSelected'}
                             className={style.bottomBaseButtonTopLine}>{getText('PLACE', this.props.store).toUpperCase()}</div>
                        <div className={style.bottomBaseButtonSeparator}></div>
                        {secondLine}
                    </div>
                );
            case SHOW:
                return (
                    <div
                        id={'selectBetTypeButton'}
                        className={style.bottomBaseButton}
                        onClick={() => this.props.store.dispatch(selectRacingBetType(WIN))}>
                        <div id={'currentBetTypeSelected'}
                             className={style.bottomBaseButtonTopLine}>{getText('SHOW', this.props.store).toUpperCase()}</div>
                        <div className={style.bottomBaseButtonSeparator}></div>
                        <div id={'nextBetTypeSelected'}
                             className={style.bottomBaseButtonBottomLine}>{getText('WIN', this.props.store).toUpperCase()}</div>
                    </div>
                );
            case EXACTA:
                if (hasTrifecta) {
                    secondLine = (
                        <div id={'nextBetTypeSelected'}
                             className={style.bottomBaseButtonBottomLine}>{getText('TRIFECTA', this.props.store).toUpperCase()}</div>
                    );
                    separator = (<div className={style.bottomBaseButtonSeparator}></div>);
                    nextBetType = TRIFECTA;
                } else {
                    secondLine = '';
                    nextBetType = EXACTA;
                    separator = '';
                }
                return (
                    <div
                        id={'selectBetTypeButton'}
                        className={style.bottomBaseButton}
                        onClick={() => this.props.store.dispatch(selectRacingBetType(nextBetType))}>
                        <div id={'currentBetTypeSelected'}
                             className={style.bottomBaseButtonTopLine}>{getText('EXACTA', this.props.store).toUpperCase()}</div>
                        {separator}
                        {secondLine}
                    </div>
                );
            case TRIFECTA:
                return (
                    <div
                        id={'selectBetTypeButton'}
                        className={style.bottomBaseButton}
                        onClick={() => this.props.store.dispatch(selectRacingBetType(EXACTA))}>
                        <div id={'currentBetTypeSelected'}
                             className={style.bottomBaseButtonTopLine}>{getText('TRIFECTA', this.props.store).toUpperCase()}</div>
                        <div className={style.bottomBaseButtonSeparator}></div>
                        <div id={'nextBetTypeSelected'}
                             className={style.bottomBaseButtonBottomLine}>{getText('EXACTA', this.props.store).toUpperCase()}</div>
                    </div>
                );
            default:
                break;
        }
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let openBetsHistory = this.state.openBetsHistory;
        let openBetsList = this.state.openBetsList;

        let bettingTypeButton;
        let selectedBetTypeButton = this._generateBetTypeSwitchButton();

        let secondChipIndex = this.state.selectedChip < CHIPS.length - 1
            ? this.state.selectedChip + 1
            : 0;

        let betsToPlace = openBetsList.slice().filter(
            (oBet) => oBet.game.channel === this.state.games[this.state.selectedGameIndex].channel && oBet.event.eventId === this.state.selectedEventId
        );

        let hasForecast = storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.forecast;
        let hasTricast = storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.tricast;

        let separator = (hasForecast || hasTricast)
            ? <div className={style.bottomBaseButtonSeparator}></div>
            : '';
        bettingTypeButton = (
            <div className={style.bottomButtonContainer}>
                <div
                    id={'bettingTypeButton'}
                    className={style.bottomBaseButton}
                    onClick={(
                        hasForecast || hasTricast)
                        ? () => this.props.store.dispatch(toggleBettingTypeButtonsDisplayed())
                        : () => ''}>
                    <div className={style.bottomBaseButtonTopLine}>{
                        getText(
                            this.state.isSimpleBetsSelected
                                ? 'SIMPLE'
                                : 'EXOTIC',
                            this.props.store
                        ).toUpperCase()
                    }</div>
                    {separator}
                    <div className={style.bottomBaseButtonBottomLine}>{
                        (hasForecast || hasTricast)
                            ? getText(
                                !this.state.isSimpleBetsSelected
                                    ? 'SIMPLE'
                                    : 'EXOTIC',
                                this.props.store
                            ).toUpperCase()
                            : ''
                    }</div>
                </div>
            </div>
        );

        //this hasForecast and hasTricast is to check if one of the Exacta or Trifecta options is selected
        hasForecast = this.state.selectedRacingBetType === EXACTA && storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.forecast;
        hasTricast = this.state.selectedRacingBetType === TRIFECTA && storeData.vpp.events[storeData.vpp.selectedEventIndex] && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList && storeData.vpp.events[storeData.vpp.selectedEventIndex].priceList.tricast;

        let toogleBoxButton;
        if (hasForecast || hasTricast) {
            let toogleStyle = this.state.isBoxBetsButtonToggled
                ? style.toggle + ' ' + style.checked
                : style.toggle;
            toogleBoxButton = (
                <div className={toogleStyle}>
                    <div className={style.checkbox} onClick={() => this.props.store.dispatch(toogleBoxBets())}/>
                    <div className={style.switch}>{getText('BOX', this.props.store)}</div>
                    <div className={style.track}></div>
                </div>
            );
        }

        let data = this.props.store.getState().vpp;
        let isTimeToShowLoading = !!this.state.games[data.selectedGameIndex].betsCommitting;
        let isTimeToShowSuccess = !!this.state.games[data.selectedGameIndex].betsCommitted;
        let isTimeToShowError = !!this.state.games[data.selectedGameIndex].betsFailedBeingCommitted;

        return (
            <div className={style.raceCardContainer}>
                <div className={style.secondBar}>
                    <div className={style.bottomButtonContainer}>
                        {selectedBetTypeButton}
                    </div>
                    <div
                        id={'undo'}
                        className={style.bottomButtonContainer}
                        onClick={() => this.props.store.dispatch(undoLastBetAction(openBetsHistory, openBetsList, this.state.selectedEventId, this.state.games[this.state.selectedGameIndex].channel))}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.undoIcon} src={`${ASSETS_URL}systemIcons/undo.svg`} alt={'undo'}/>
                            <div
                                className={style.bottomBaseButtonBottomIconLine}>{getText('UNDO', this.props.store).toUpperCase()}</div>
                        </div>
                    </div>
                    <div className={style.separator}>
                        {toogleBoxButton}
                    </div>
                    <div id={'undoAll'} className={style.bottomButtonContainer}
                         onClick={() => this.props.store.dispatch(removeAllBets())}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.undoAllIcon} src={`${ASSETS_URL}systemIcons/undoall.svg`}
                                 alt={'clear'}/>
                            <div
                                className={style.bottomBaseButtonBottomIconLine}>{getText('CLEAR', this.props.store).toUpperCase()}</div>
                        </div>
                    </div>
                    <div className={style.bottomButtonContainer}>
                        <div
                            id={'chipsSelector'}
                            className={style.chipIconContainer}
                            onClick={() => this.props.store.dispatch(openCloseModal(CHIPS_LIST_MODAL_TYPE))}>
                            <div className={style.chipValueOuter}>
                                <div
                                    className={style.chipValueInner}>{getFormattedCurrency(this.props.store, getHumanReadableChipValue(this.state.selectedChip).toString(), 0)}</div>
                            </div>
                            <img className={style.chipIcon} src={ASSETS_URL + CHIPS[this.state.selectedChip].assetChip}
                                 alt={'chips'}/>
                            <img className={style.secondChipIcon} src={ASSETS_URL + CHIPS[secondChipIndex].assetChip}
                                 alt={'chips'}/>
                        </div>
                    </div>
                </div>
                <div className={style.bottomBar}>
                    {bettingTypeButton}
                    <div id={'settings'} className={style.bottomButtonContainer}
                         onClick={() => this.props.store.dispatch(openCloseSettings())}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.settingsIcon} src={`${ASSETS_URL}systemIcons/cog.svg`}
                                 alt={'settings'}/>
                        </div>
                    </div>
                    <div
                        id={'placeBets'}
                        className={style.bottomButtonContainer}
                        onClick={() => betsToPlace.length > 0
                            ? this._placeBets(this.props.store.getState(), this.props.store.dispatch)
                            : null}>
                        <div
                            className={`${style.placeBetsButton} ${betsToPlace.length > 0
                                ? style.enabled
                                : null}`}>
                            {
                                !isTimeToShowLoading && !isTimeToShowSuccess && !isTimeToShowError
                                    ? <div
                                        className={style.bottomBaseButtonBottomLine}>{getText('PLACE_BETS', this.props.store).toUpperCase()}</div>
                                    : ''
                            }
                            {
                                isTimeToShowLoading
                                    ? <div className={style.circleLoaderContainer}>
                                        <div className={style.circleLoader}/>
                                    </div>
                                    : ''
                            }
                            {
                                isTimeToShowSuccess
                                    ? <div className={style.circleLoaderContainer}>
                                        <div className={style.checkmarkContainer}>
                                            <div className={style.checkmark}/>
                                        </div>
                                    </div>
                                    : ''
                            }
                            {
                                isTimeToShowError
                                    ? <div className={style.circleLoaderContainer}>
                                        <div className={style.errormarkContainer}>
                                            <div className={style.errormark}/>
                                        </div>
                                    </div>
                                    : ''
                            }
                        </div>
                    </div>
                    <div id={'help'} className={style.bottomButtonContainer}
                         onClick={() => this.props.store.dispatch(openCloseHelpPages())}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.infoIcon} src={`${ASSETS_URL}systemIcons/info.svg`} alt={'help'}/>
                        </div>
                    </div>
                    <div className={style.bottomButtonContainer}>
                        <div
                            id={'betHistory'}
                            className={`${style.bottomBaseButton} ${this.state.flashBetHistoryButton
                                ? style.flashingButton
                                : ''}`}
                            onClick={() => this.props.store.dispatch(openCloseBetBetHistory())}>
                            <img className={style.historyclockIcon} src={`${ASSETS_URL}systemIcons/historyclock.svg`}
                                 alt={'history'}/>
                            <div
                                className={style.bottomBaseButtonBottomIconLine}>{getText('HISTORY', this.props.store).toUpperCase()}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _placeBets(store, dispatch) {
        if (OPERATOR.clientType === 'Simplified') {
            if (process.env.NODE_ENV !== 'development') {
                placeAndClearOpenBets(
                    store.vpp.games[store.vpp.selectedGameIndex].channel,
                    store.vpp.selectedEventId,
                    undefined,
                    store,
                    dispatch
                );
            } else {
                fakePlaceBets(store.vpp.games[store.vpp.selectedGameIndex].channel, dispatch);
                dispatch(clearEventOpenBets(store.vpp.games[store.vpp.selectedGameIndex].channel, store.vpp.selectedEventId));
            }
        }
    }
}

export default connect(mapStateToProps)(BottomBar);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/racing/containers/bottomBar.js